import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { UserInfo } from './user-info';

interface UserProps {
  authenticated: boolean;
  loggingOut: boolean;
  info: UserInfo | undefined;
  agentAutomationDivision: string | undefined;
  mobile: false;
  tokenRefreshStatus: 'idle' | 'refreshing' | 'refreshed' | 'error';
}

const UserStore = createStore(
  { name: 'user' },
  withProps<UserProps>({
    authenticated: false,
    info: undefined,
    agentAutomationDivision: undefined,
    loggingOut: false,
    mobile: false,
    tokenRefreshStatus: 'idle',
  })
);

export const userAuthenticated$: Observable<boolean> = UserStore.pipe(
  select((state) => state.authenticated)
);

export const isUserAuthenticated = () => {
  return UserStore.state.authenticated;
};

export const loggingOut$: Observable<boolean> = UserStore.pipe(
  select((state) => state.loggingOut)
);

export const userInfo$: Observable<UserInfo | undefined> = UserStore.pipe(
  select((state) => state.info)
);

export const userInfo = () => {
  return UserStore.state.info;
};

export const hasPermission$ = (permission: string) => {
  return UserStore.pipe(
    select((state) => state.info?.frontActions.includes(permission))
  );
};

export function setMobile(mobile: boolean) {
  if (mobile) {
    console.log(
      'Mobile size:',
      typeof mobile === 'boolean' ? mobile : 'invalid'
    );
  }
  UserStore.update((state: any) => ({
    ...state,
    mobile,
  }));
}

export const isMobile$ = UserStore.pipe(select((state) => state?.mobile));
export const isMobile = () => UserStore.state?.mobile;

export const hasPermission = (permission: string) => {
  return UserStore.state.info?.frontActions.includes(permission);
};

export const isLoggingOut = () => {
  return UserStore.state.loggingOut;
};

export const userDivision$: Observable<string | undefined> = UserStore.pipe(
  select((state) => state?.agentAutomationDivision)
);

export function setUserDivision(division: string) {
  UserStore.update((state: any) => ({
    ...state,
    agentAutomationDivision: division,
  }));
}

export function setUserAuthenticated(authenticated: boolean) {
  UserStore.update((state) => ({
    ...state,
    authenticated,
  }));
}

export function loggingOut() {
  console.log('Logging out...');
  UserStore.update((state) => ({
    ...state,
    loggingOut: true,
  }));
}

export function setUserInfo(userInfo: UserInfo) {
  UserStore.update((state) => ({
    ...state,
    info: userInfo,
  }));
}

export const tokenRefreshStatus$ = UserStore.pipe(
  select((state) => state.tokenRefreshStatus)
);

export function setTokenRefreshStatus(status: 'idle' | 'refreshing' | 'refreshed' | 'error') {
  UserStore.update((state) => ({ ...state, tokenRefreshStatus: status }));
}
